const findStepAppMetadata = (step, appsMetadata = []) => {
  return appsMetadata?.find((n) => n?.id === step?.appId);
};

export default findStepAppMetadata;
